<script setup>
import { SOCIAL_SHARE_IMAGE, usePageHead } from '@composables/use-page-head'
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import Layout from '@layouts/main-layout'
import PlaylistsGridBlock from '@components/playlists/playlists-grid-block'

const charts = ref([])
const featuredCharts = ref([])

// A chart with no published revision has no cover art and no tracklist to show.
const isPublished = playlist =>
    playlist.revisions_id !== null &&
    playlist.revisions_album_art &&
    playlist.revisions_album_art.filename

onMounted(() => {
    DataLayer.playlists.getByType({ type: 'chart' }).then(response => {
        response.body.filter(isPublished).forEach(playlist => {
            if (playlist.featured === 1) {
                featuredCharts.value.push(playlist)
            } else {
                charts.value.push(playlist)
            }
        })
    })
})

usePageHead({
    title: 'Charts',
    description: 'Top-curated charts of underground electronic mixes on FRISKY.',
    image: SOCIAL_SHARE_IMAGE,
})
</script>

<template>
    <Layout>
        <BaseContent title="Charts">
            <BaseSection
                v-if="featuredCharts && featuredCharts.length"
                title="Featured Charts"
                padded
            >
                <PlaylistsGridBlock
                    :playlists="featuredCharts"
                    type="charts"
                />
            </BaseSection>
            <BaseSection padded>
                <PlaylistsGridBlock
                    :playlists="charts"
                    type="charts"
                />
            </BaseSection>
        </BaseContent>
    </Layout>
</template>
